var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ui-view",
    {
      directives: [
        {
          name: "spinner",
          rawName: "v-spinner",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "view-lot-form",
      attrs: { hide: _vm.loading },
    },
    [
      _c(
        "ui-heading",
        { attrs: { title: _vm.pageTitle, icon: "magicon-resize-plus-3" } },
        [
          _vm.$can("MUTATE_PARCELS")
            ? _c(
                "ui-button",
                {
                  attrs: { color: "positive", loading: _vm.submitting },
                  on: {
                    click: function ($event) {
                      return _vm.$refs.form.submit()
                    },
                  },
                },
                [_vm._v("Opslaan")]
              )
            : _vm._e(),
          _vm.parcelId && _vm.$can("MUTATE_PARCELS")
            ? _c(
                "ui-button",
                {
                  attrs: { color: "negative", icon: "magicon-trash" },
                  on: { click: _vm.deleteParcel },
                },
                [_vm._v("Verwijderen")]
              )
            : _vm._e(),
          _c(
            "ui-button",
            {
              attrs: { slot: "left", color: "medium", type: "bordered" },
              on: {
                click: function ($event) {
                  return _vm.$router.go(-1)
                },
              },
              slot: "left",
            },
            [_vm._v("Annuleren")]
          ),
        ],
        1
      ),
      _c(
        "ui-form-panel",
        {
          ref: "form",
          attrs: { "auto-validate": "" },
          on: { submit: _vm.submit },
        },
        [
          _c("ui-form-dropdown", {
            attrs: {
              searchable: "",
              title: "Perceel",
              name: "parcelLocationId",
              options: _vm.parcelLocationOptions,
              rules: "required",
            },
            model: {
              value: _vm.pendingParcel.parcelLocationId,
              callback: function ($$v) {
                _vm.$set(_vm.pendingParcel, "parcelLocationId", $$v)
              },
              expression: "pendingParcel.parcelLocationId",
            },
          }),
          _c("ui-form-input", {
            attrs: {
              title: "Perceel oppervlakte (ha)",
              name: "size",
              rules: "required",
              decimal: "",
            },
            model: {
              value: _vm.pendingParcel.size,
              callback: function ($$v) {
                _vm.$set(_vm.pendingParcel, "size", $$v)
              },
              expression: "pendingParcel.size",
            },
          }),
          _c("ui-form-input", {
            attrs: { title: "Alias", name: "alias" },
            model: {
              value: _vm.pendingParcel.alias,
              callback: function ($$v) {
                _vm.$set(_vm.pendingParcel, "alias", $$v)
              },
              expression: "pendingParcel.alias",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }